import SubcategoryService from '../../../modules/subcategory/subcategoryService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'SUBCATEGORY_FORM'

const subcategoryFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: subcategoryFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await SubcategoryService.find(id)
      }

      dispatch({
        type: subcategoryFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: subcategoryFormActions.INIT_ERROR,
      })

      dispatch(push('/subcategory'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: subcategoryFormActions.CREATE_STARTED,
      })

      await SubcategoryService.create(values)

      dispatch({
        type: subcategoryFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.subcategory.create.success'),
      )

      dispatch(push('/subcategory'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: subcategoryFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: subcategoryFormActions.UPDATE_STARTED,
      })

      await SubcategoryService.update(id, values)

      dispatch({
        type: subcategoryFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.subcategory.update.success'),
      )

      dispatch(push('/subcategory'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: subcategoryFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default subcategoryFormActions
